<!-- KYMW0002 タグ選択 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">タグ選択</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="panel-body">
          <div class="element-column">
            <div class="column-list">
              <!-- タグ名 -->
              <label class="list-input-title item-title">タグ名</label>
              <div class="list-input-content">
                <wj-auto-complete #wac_TagName id="wac_TagName" [isRequired]="false" [isEditable]="true" [minLength]="1"
                  [showDropDownButton]="false" [itemsSource]="model.tagNameList" class="combo-box" style="width: 460px;"
                  (textChanged)="inputRestrict(wac_TagName)" [tabindex]="0"></wj-auto-complete>
              </div>
            </div>
            <button #btn_Filter id="btn_Filter" class="btn-secondary btn-add-new-group" (click)="filter()"
              [tabindex]="0">タグ名絞込</button>
            <!-- タググループ 表示エリア -->
            <div class="accordion-area">
              <div class="element-column">
                <ng-template ngFor let-item [ngForOf]="model.dspTagGroupList" let-i="index">
                  <wj-accordion #wja [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
                    (initialized)="initCollapsed(wja, !item.open)">
                    <wj-accordion-pane>
                      <div>{{item.tagGroupName}}</div>
                      <div>
                        <!-- FlexGrid -->
                        <wj-flex-grid #grid (initialized)="onInitialized(grid)" *ngIf="item.tags.length"
                          [itemsSource]="item.tags" [allowDragging]="'None'" horizontalScrollPolicy="'off'"
                          [headersVisibility]="'Column'" [selectionMode]="'Row'" verticalScrollPolicy="'on'"
                          [allowSorting]="false" [autoRowHeights]="true" [tabindex]="-1">
                          <!-- column チェックボックス -->
                          <wj-flex-grid-column [header]="' '" [width]="40" [binding]="'check'" [align]="'center'"
                            [isReadOnly]="true" [minWidth]="5">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                              <input type="checkbox" class="selected" [(ngModel)]="cell.item.check"
                                (click)="checkCell(cell.item.tagId);$event.stopPropagation();" [tabindex]="-1" />
                            </ng-template>
                          </wj-flex-grid-column>
                          <!-- column タグ名 -->
                          <wj-flex-grid-column [header]="'タグ名'" [width]="488" [binding]="'tagName'"
                            [isReadOnly]="true" [minWidth]="5"></wj-flex-grid-column>
                        </wj-flex-grid>
                      </div>
                    </wj-accordion-pane>
                  </wj-accordion>
                </ng-template>
              </div>

            </div>
          </div>
        </div><!-- div panel-body -->
      </div><!-- div contents-area -->
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 選択 -->
          <button #btn_Choose id="btn_Choose" class="btn-primary" (click)="Choose()" [tabindex]="0">選択</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>